//TODO: TableRowをMUI側に統一
import { TableRow } from "@aws-amplify/ui-react";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Alert, Avatar, CircularProgress, Grid, IconButton, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, Tooltip, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import { FlightInfo, FlightTimeInformation, WaypointWeatherGeoJson } from "adoms-common-lib";
import dayjs, { extend } from 'dayjs';
import duration from 'dayjs/plugin/duration';
import type { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import React from 'react';
extend(duration);

const TitlePaper = styled(Paper)(({ theme }) => ({
    textAlign: "center",
    padding: 4,
    backgroundColor: "#EFEFEF",
    height: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center"
}));

const ValuePaper = styled(Paper)(({ theme }) => ({
    textAlign: "center",
    padding: 4,
    height: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center"
}));

type WaypointWindProps = {
    selectedFlightInfo: FlightInfo | undefined
    waypointWeatherGeoJson: WaypointWeatherGeoJson | undefined
    setWaypointWeatherGeoJson: React.Dispatch<React.SetStateAction<WaypointWeatherGeoJson | undefined>>
    waypointWindErrorMessage: string | undefined
    setWaypointWindErrorMessage: React.Dispatch<React.SetStateAction<string | undefined>>
    isDisplayWaypointWindLoading: boolean
    setDisplayWaypointWindLoading: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedFlightEtd: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedFlightEtd: string | undefined
    routeDataMap: Map<string, FeatureCollection<Geometry, GeoJsonProperties> | undefined> | undefined
    routeErrorMessage?: string
    isFilter: boolean
    setFilter: React.Dispatch<React.SetStateAction<boolean>>
}

export const WaypointWindGrid: React.FC<WaypointWindProps> = (props) => {
    const calcETA = (flightTimeInformationList: FlightTimeInformation[]) => {
        let gsFlightTimeTotalSec = 0;
        flightTimeInformationList.map((flightTimeInformation) => {
            gsFlightTimeTotalSec = gsFlightTimeTotalSec + flightTimeInformation.gsFlightTimeTotalSec;
        });
        let etaDayJs = dayjs(props.selectedFlightInfo?.flightDate + " " + props.selectedFlightEtd);
        etaDayJs = etaDayJs.add(gsFlightTimeTotalSec, "seconds");
        return (<Grid item>
            <ValuePaper elevation={0} variant="outlined" >
                <Typography variant='subtitle2' whiteSpace={"pre-wrap"} sx={{ color: "#0000cd", fontWeight: "bold" }}>{etaDayJs.format("HH:mm:ss")}</Typography>
            </ValuePaper>
        </Grid>);
    };

    const calcGsTotalFlightTime = (flightTimeInformationList: FlightTimeInformation[]) => {
        let gsFlightTimeTotalSec = 0;
        flightTimeInformationList.map((flightTimeInformation) => {
            gsFlightTimeTotalSec = gsFlightTimeTotalSec + flightTimeInformation.gsFlightTimeTotalSec;
        });
        extend(duration);
        let etaDayJs = dayjs.duration(gsFlightTimeTotalSec, "second");
        return (<Grid item>
            <ValuePaper elevation={0} variant="outlined" >
                <Typography variant='subtitle2' whiteSpace={"pre-wrap"} sx={{ color: "#0000cd", fontWeight: "bold" }}>{etaDayJs.format("HH:mm:ss")}</Typography>
            </ValuePaper>
        </Grid>);
    };

    const displayTableRow = () => {
        let tableRowList: JSX.Element[] = new Array();
        if (props.waypointWeatherGeoJson && props.routeDataMap) {
            let gsFlightTimeTotalSec = 0;
            for (let index = 0; index < props.waypointWeatherGeoJson.flightTimeInformationList.length; index++) {
                let features = props.routeDataMap.get(props.selectedFlightInfo!.id)?.features;
                let reverseFlg = false;
                if (features) {
                    features.find((feature) => {
                        const name = feature?.properties?.name;
                        if (name != null && name.includes("飛行経路")) {
                            const nameParts = name.split("_");
                            if (nameParts[1] === props.selectedFlightInfo?.arrival.id
                                && nameParts[2] === props.selectedFlightInfo?.departure.id) {
                                reverseFlg = true;
                            };
                            return true;
                        };
                    });

                    features = features.filter((feature) => {
                        return feature.geometry.type === "Point";
                    });

                    if (reverseFlg) {
                        features.reverse();
                    };

                    if (props.selectedFlightInfo?.departure.isMobile) {
                        features.unshift({
                            type: "Feature",
                            properties: { name: "艦艇" },
                            geometry: {
                                type: "Point",
                                coordinates: [Number(props.selectedFlightInfo.departure.longitude), Number(props.selectedFlightInfo.departure.latitude), 0]
                            }
                        });
                    } else if (props.selectedFlightInfo?.arrival.isMobile) {
                        features.push({
                            type: "Feature",
                            properties: { name: "艦艇" },
                            geometry: {
                                type: "Point",
                                coordinates: [Number(props.selectedFlightInfo.arrival.longitude), Number(props.selectedFlightInfo.arrival.latitude), 0]
                            }
                        });
                    }

                    const feature = features[index + 1];

                    if (feature) {

                        const flightTimeInformation = props.waypointWeatherGeoJson.flightTimeInformationList[index];
                        gsFlightTimeTotalSec = gsFlightTimeTotalSec + flightTimeInformation.gsFlightTimeTotalSec;
                        let etaDayJs = dayjs(props.selectedFlightInfo?.flightDate + " " + props.selectedFlightEtd);
                        etaDayJs = etaDayJs.add(gsFlightTimeTotalSec, "seconds");

                        if (props.isFilter) {
                            if (feature.properties?.visibility !== false) {
                                tableRowList.push(
                                    <TableRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                        <TableCell align="center">{feature.properties?.name}</TableCell>
                                        <TableCell align="center" sx={{ color: "#0000cd", fontWeight: "bold" }}>{etaDayJs.format("HH:mm:ss")}</TableCell>
                                        <TableCell align="center">{flightTimeInformation.gsFlightTime_hhmmss}</TableCell>
                                        <TableCell align="center">{flightTimeInformation.gs_msec.toString()}</TableCell>
                                        <TableCell align="center">{flightTimeInformation.distance_m.toString()}</TableCell>
                                        <TableCell align="center">{flightTimeInformation.course_deg.toString()}</TableCell>
                                        <TableCell align="center">{flightTimeInformation.wca_deg.toString()}</TableCell>
                                    </TableRow>)
                            }
                        } else {
                            tableRowList.push(
                                <TableRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <TableCell align="center">{feature.properties?.name}</TableCell>
                                    <TableCell align="center" sx={{ color: "#0000cd", fontWeight: "bold" }}>{etaDayJs.format("HH:mm:ss")}</TableCell>
                                    <TableCell align="center">{flightTimeInformation.gsFlightTime_hhmmss}</TableCell>
                                    <TableCell align="center">{flightTimeInformation.gs_msec.toString()}</TableCell>
                                    <TableCell align="center">{flightTimeInformation.distance_m.toString()}</TableCell>
                                    <TableCell align="center">{flightTimeInformation.course_deg.toString()}</TableCell>
                                    <TableCell align="center">{flightTimeInformation.wca_deg.toString()}</TableCell>
                                </TableRow>)
                        }
                    }
                }
            }
        }
        return tableRowList;
    }

    return (
        props.isDisplayWaypointWindLoading ?
            <Grid textAlign={"center"}>
                <CircularProgress />
            </Grid >
            :
            props.selectedFlightInfo && props.waypointWeatherGeoJson
                && props.waypointWeatherGeoJson.flightTimeInformationList.length > 0 ?
                props.waypointWindErrorMessage ?
                    <Grid item xs>
                        <Alert severity="error" >{props.waypointWindErrorMessage}</Alert>
                    </Grid> :
                    <>
                        <Grid container spacing={2} justifyContent="space-between">
                            <Grid item>
                                <Grid item container spacing={1} wrap={"nowrap"}>
                                    <Grid item>
                                        <TitlePaper elevation={0}>
                                            <Typography variant='subtitle2' whiteSpace={"pre"}>ETA</Typography>
                                        </TitlePaper>
                                    </Grid>
                                    {calcETA(props.waypointWeatherGeoJson.flightTimeInformationList)}
                                    <Grid item>
                                        <TitlePaper elevation={0}>
                                            <Typography variant='subtitle2' whiteSpace={"pre"}>総飛行時間</Typography>
                                        </TitlePaper>
                                    </Grid>
                                    {calcGsTotalFlightTime(props.waypointWeatherGeoJson.flightTimeInformationList)}
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container>
                                    <Grid item>
                                        <Tooltip title="フィルター">
                                            <IconButton
                                                onClick={() => props.setFilter(!props.isFilter)}
                                                size="small">
                                                <Avatar variant="rounded" sx={{ bgcolor: blue[500] }}>
                                                    {props.isFilter ?
                                                        <FilterAltIcon /> : <FilterAltOffIcon />}
                                                </Avatar>
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container spacing={1} >
                                <TableContainer sx={{ maxHeight: `calc(100vh - 260px)`, overflow: 'auto' }}>
                                    <Table size="small">
                                        <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: "#EFEFEF", zIndex: 1, whiteSpace: "nowrap" }}>
                                            <TableRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                                <TableCell align="center">waypoint</TableCell>
                                                <TableCell align="center">ETA</TableCell>
                                                <TableCell align="center">飛行時間</TableCell>
                                                <TableCell align="center">GS(m/s)</TableCell>
                                                <TableCell align="center">距離(m)</TableCell>
                                                <TableCell align="center">Course(deg)</TableCell>
                                                <TableCell align="center">WCA(deg)</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {displayTableRow()}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </>
                :
                <Alert severity="info" >フライトを選択するとwaypointごとのETAが表示されます</Alert>
    )
}